import { ButtonHTMLAttributes, DetailedHTMLProps, PropsWithChildren } from "react";

type PropType = PropsWithChildren<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
>;

export const PrevButton = (props: PropType) => {
  const { children, ...restProps } = props;

  return (
    <button className="c-gallery__button c-gallery__button--previous" type="button" {...restProps}>
      {children}
    </button>
  );
};

export const NextButton = (props: PropType) => {
  const { children, ...restProps } = props;

  return (
    <button className="c-gallery__button c-gallery__button--next" type="button" {...restProps}>
      {children}
    </button>
  );
};
